// return the token from the session storage
export const getToken = () => {
    return localStorage.getItem("token") || null;
};

export const getCompanyToken = () => {
    return localStorage.getItem("company_token") || null;
};